import React from 'react';
import styled from '@emotion/styled';
import { Popper } from '../Popper/Popper.es.js';

const Wrapper = styled(Popper) `
  background: #434657;
  padding: 16px;
  border-radius: 4px;
  color: #fff;
  display: flex;
  flex-direction: column;
  max-width: 300px;
  z-index: 1070;
  .arrow {
    position: absolute;
    width: 10px;
    height: 10px;

    &:after {
      content: ' ';
      position: absolute;
      top: 0;
      left: 0;
      transform: rotate(45deg);
      width: 10px;
      height: 10px;
      background-color: #434657;
    }
  }
  &[data-popper-placement^='bottom'] > .arrow {
    top: -5px;
  }
  &[data-popper-placement^='top'] > .arrow {
    bottom: -5px;
  }
  &[data-popper-placement^='right'] > .arrow {
    left: -5px;
  }
  &[data-popper-placement^='left'] > .arrow {
    right: -5px;
  }
`;
const Tooltip = ({ children, referenceElement, className, isVisible, placement = 'right-end', }) => {
    if (!isVisible)
        return null;
    return (React.createElement(Wrapper, { referenceElement: referenceElement.current, placement: placement, className: className }, children));
};

export { Tooltip };
